export default [
    {
        path: '/product',
        props: true,
        component: () => import('@/views/ProductPackage'),
    },
    {
        path: '/product-package',
        props: true,
        component: () => import('@/views/ProductPackage/Show'),
        children: [
            {
                path: '/product/price/modification/:productId',
                component: () => import('@/views/Product/Price/Modification/index'),
                props: true,
                meta: {
                    type: 'price-modification',
                },
                children: [
                    {
                        path: '',
                        component: () => import('@/views/Product/Price/Modification/Show/Allowance'),

                        props: true,
                        meta: {
                            type: 'price-modification',
                            subview: '',
                        },
                    },
                    {
                        path: 'discount',
                        component: () => import('@/views/Product/Price/Modification/Show/Discount'),
                        props: true,
                        meta: {
                            type: 'price-modification',
                            subview: 'discount',
                        },
                    },
                    {
                        path: 'period-allowance',
                        component: () => import('@/views/Product/Price/PeriodAllowance'),
                        props: true,
                        meta: {
                            type: 'price-modification',
                            subview: 'period-allowance',
                        },
                    },
                ]
            },
            {
                path: '/product/:productId',
                component: () => import('@/views/Product/Show'),
                props: true,
                meta: {
                    type: 'general'
                },
                children: [
                    {
                        path: '',
                        component: () => import('@/views/Product/Show/Internal'),
                        props: true,
                        meta: {
                            type: 'general',
                            subview: '',
                        },
                    },
                    {
                        path: 'general',
                        component: () => import('@/views/Product/Show/General'),
                        props: true,
                        meta: {
                            type: 'general',
                            subview: 'general',
                        },
                    },
                    {
                        path: 'website',
                        component: () => import('@/views/Product/Show/Website'),
                        props: true,
                        meta: {
                            type: 'general',
                            subview: 'website',
                        },
                    },
                    {
                        path: 'day-schedule',
                        component: () => import('@/views/Product/Show/DaySchedule'),
                        props: true,
                        meta: {
                            type: 'general',
                            subview: 'day-schedule',
                        },
                    }
                ],
            },
            {
                path: '/sale/product/:productId',
                component: () => import('@/views/Product/CalculatePrice'),
                props: true,
                meta: {
                    type: 'sale'
                },
            },
            {
                path: '/package/:packageId',
                component: () => import('@/views/Package/Show'),
                props: true,
                meta: {
                    type: 'general'
                },
                children: [
                    {
                        path: '',
                        component: () => import('@/views/Package/Show/Internal'),
                        props: true,
                        meta: {
                            type: 'general',
                            subview: '',
                        },
                    },
                    {
                        path: 'general',
                        component: () => import('@/views/Package/Show/General'),
                        props: true,
                        meta: {
                            type: 'general',
                            subview: 'general',
                        },
                    },
                    {
                        path: 'website',
                        component: () => import('@/views/Package/Show/Website'),
                        props: true,
                        meta: {
                            type: 'general',
                            subview: 'website',
                        },
                    }
                ],
            },
            {
                path: '/sale/package/:packageId',
                props: true,
                component: () => import('@/views/Sale/Package'),
                meta: {
                    type: 'sale'
                },
            },
            {
                path: '/product/purchase/:productId',
                props: true,
                component: () => import('@/views/Product/Purchase'),
                meta: {
                    type: 'purchase'
                },
            },
        ]
    }
];
